import { z } from 'zod';

/**
 * Mirrors the backend's `PasswordValidationRules::passwordRules()` (`min:5`) -
 * the legacy site's minimum, kept on purpose so existing habits and accounts
 * survive the cutover. The API stays the authority; this only saves a round
 * trip, so it must never be stricter than the server.
 */
export const PASSWORD_MIN_LENGTH = 5;

export const newPasswordSchema = z.string().min(PASSWORD_MIN_LENGTH);
